import React from 'react';
import { Transition } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import envConfig from '../../../envConfig';
import './footer.css';

function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="footer-main bg-footer" id="footer">
      <Transition
        appear
        show
        key="footer"
        enter="transform transition duration-700 ease-in-out"
        enterFrom="opacity-0 translate-y-full"
        enterTo="opacity-100 translate-y-0"
        leave="transform duration-200 transition ease-in-out"
        leaveFrom="opacity-100 -translate-x-0"
        leaveTo="opacity-0 -translate-x-full"
        className="flex bg-footer justify-center items-center flex-shrink-0 mb-2 font-medium text-sm"
      >
        <div className="footer-content bg-footer pt-4 flex flex-col justify-center w-full">
          <div>{t('copyright')} © {new Date().getFullYear()} {envConfig.SiteTitle}</div>
          <div className="flex flex-row p-2">
            <a href={`mailto:${envConfig.ContactEmail}`} className="text-accent hover:underline text-sm font-regular tracking-tight transition duration-500 ease-in-out outline-none focus:outline-none ring-0 focus:ring-0 mr-2">{t('contact_us')}</a>
            {/* <a href={envConfig.TosUrl} target="_blank" rel="noreferrer" className="hidden hover:underline text-sm font-regular tracking-tight transition duration-500 ease-in-out outline-none focus:outline-none ring-0 focus:ring-0">Terminos de Uso</a> */}
          </div>
          <div className="flex flex-row items-center justify-center p-2 shadow-lg">
            {/* <p className="mx-4 font-semibold text-3xl text-yellow-500">solarX</p> */}
            {/* <img src={bpslogo} alt="bright planet solar" className="mx-4 h-6 w-auto" /> */}
            {/* <img src={sunrunlogo} alt="sunrun" className="mx-4 h-4 w-auto" />          */}
          </div>
        </div>
      </Transition>
    </footer>
  );
}

export default Footer;
